// /* eslint-disable */
import React, {
  useMemo,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Modal, Button, Upload, Typography, message,Divider } from "antd";
import {
  UploadOutlined,
  MenuOutlined,
  FileTextOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import warningIcon from "@/assets/images/icons/warning_2.png";
import moneyIcon from "@/assets/images/icons/money_4.png";
import rowsIcon from "@/assets/images/icons/rows.png";
import propIcon from "@/assets/images/icons/prop.png";
import { formatDateText } from "@/utils/date";
const { Text } = Typography;

const UploadTransactionsModal = forwardRef((props, ref) => {
  const { onFileSelected } = props;
  const { onSuccess } = props;
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("transactions");
  const [fileList, setFileList] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [uploading, setUploading] = useState(false);
  const [excelUploading, setExcelUploading] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);
  const [checkModalVisible, setCheckModalVisible] = useState(false);
  const [checkResult, setCheckResult] = useState(null);
  const [checkMsg, setCheckMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);
 const [currentRecord, setCurrentRecord] = useState(null);
  useImperativeHandle(ref, () => ({
    open: (config = {}) => {
      setType(config.type || "transactions");
      setCurrentRecord(config.record || null); 
      setOpen(true);
    },
    close: () => setOpen(false),
  }));

  const reset = () => {
    setFileList([]);
    setErrorMsg("");
    setUploading(false);
    setPendingFile(null);
    setCheckResult(null);
    setCheckMsg("");
    setCheckModalVisible(false);
    setCurrentRecord(null);
  };

  const handleDownloadInstruction = () => {
    const link = document.createElement("a");
    link.href = "/files/Insurance.zip";
    link.download = "Insurance.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 校验接口
const beforeUpload = async (file) => {
  const isExcel = /\.(xlsx|xls)$/i.test(file?.name || "");
  if (!isExcel) {
    message.error("Please upload an Excel file (.xlsx or .xls).");
    return Upload.LIST_IGNORE;
  }

  const formData = new FormData();
  formData.append("file", file);
//   formData.append("foreignId", currentRecord.id); 
//  formData.append("carrier", currentRecord.carrier); 
//  formData.append("payeeVendorId", currentRecord.payeeVendorId); 
//   formData.append("agentVendorId", currentRecord.agentVendorId); 
  try {
    setExcelUploading(true);

    // // 调用校验接口
    const res = await http.post(api.getInstanceCheckByExcl, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res?.code === "1") {
      setPendingFile(file);
      setCheckResult(res?.data);
      setCheckMsg("");
      setCheckModalVisible(true);
    } else {
      setPendingFile(null);
      setCheckResult(null);
      setCheckMsg(res?.msg || "Check failed");
      setCheckModalVisible(true);
    }
  } catch (e) {
    message.error("Check failed");
    setCheckModalVisible(false);
  } finally {
    setExcelUploading(false);
  }

  return false;
};
  // 提交接口
  const handleSubmitUpload = async () => {
    if (!pendingFile) return;

    const currentFile = pendingFile?.originFileObj || pendingFile;
    const formData = new FormData();
    formData.append("file", currentFile);
    // formData.append("foreignId", currentRecord.id); 
    setSubmitting(true);
    try {
    
      const res = await http.post(api.getInstanceByExcl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      
      if (res?.code === "1") {
        message.success(res?.msg || "Upload successfully.");
        setCheckModalVisible(false);
        setOpen(false);
        onSuccess && onSuccess();
        reset();
      } else {
        message.error(res?.msg || "Upload failed.");
      }
    } catch (err) {
      message.error("Upload failed.");
    } finally {
      setSubmitting(false);
    }
  };


const handleConfirmUpload = async () => {
  if (!pendingFile || checkMsg) return;
  await handleSubmitUpload();
};

const handleCancelCheck = () => {
  setCheckModalVisible(false);
  setPendingFile(null);
  setCheckResult(null);
  setCheckMsg("");
};


const renderCheckResult = () => {

  if (!checkResult && checkMsg) {
    return (
      <div className="check-result">
        <div className="policy-box error-box">
          <div className="policy-alert error">
            <img src={warningIcon} alt="icon" />
            <div className="error-msg" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
              {checkMsg}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!checkResult) return null;

  const isDuplicate = checkResult.isExistingPolicy === true;

  return (
    <div className="check-result">
      <div className="policy-box">
        <div className="policy-left">
          <div className="label">Policy Number</div>
          <div className="value">{checkResult.policyNumber}</div>
        </div>
        <div className="insuranceDivider" />
        <div className={`policy-alert ${isDuplicate ? "duplicate" : "valid"}`}>
          <img src={warningIcon} alt="icon" />
          <div>
            <div className="alert-title">
              {isDuplicate ? "Duplicate - Already Exists" : "Valid - New Policy"}
            </div>
            <div className="alert-desc">
              {isDuplicate
                ? "This policy number already exists in the system"
                : "This policy number is ready to upload"}
            </div>
          </div>
        </div>
      </div>

      {/* Summary - 只在成功时显示 */}
      <div className="summary">
        <div className="summary-title">Summary</div>

        <div className="summary-cards">
          {/* Total Rows */}
          <div className="card">
            <div className="card-icon">
              <img src={rowsIcon} alt="rows" />
            </div>
            <div className="card-content">
              <div className="card-label">Total Rows</div>
              <div className="card-value">
                {checkResult.totalRows || 0}
              </div>
            </div>
          </div>

          {/* Total Amount */}
          <div className="card">
            <div className="card-icon green">
              <img src={moneyIcon} alt="money" />
            </div>
            <div className="card-content">
              <div className="card-label">Total Amount</div>
              <div className="card-value">
                {checkResult.totalAmount || "$0"}
              </div>
            </div>
          </div>

          {/* Total Properties */}
          <div className="card">
            <div className="card-icon purple">
              <img src={propIcon} alt="prop" />
            </div>
            <div className="card-content">
              <div className="card-label">Total Properties</div>
              <div className="card-value">
                {checkResult.totalPropCount || 0}
              </div>
            </div>
          </div>
        </div>
      </div>

          {/* 新增：Policy Detail 信息 */}
      <div className="policy-detail">
        <div className="summary-title">Policy Detail</div>
        <div className="detail-grid">
      
          <div className="detail-item">
            <div className="detail-label">Effective Date</div>
            <div className="detail-value">{formatDateText(checkResult.effectiveDate)}</div>
          </div>
          <div className="detail-item">
            <div className="detail-label">Expiration Date</div>
            <div className="detail-value">{formatDateText(checkResult.expirationDate)}</div>
          </div>
           <div className="detail-item">
            <div className="detail-label">Carrier</div>
            <div className="detail-value">{checkResult.carrier || "-"}</div>
          </div>
          <div className="detail-item">
            <div className="detail-label">Payee</div>
            <div className="detail-value">{checkResult.payeeVendorName || "-"}</div>
          </div>
        </div>
      </div>

    </div>
  );
};

  return (
    <>
    
      <Modal
        open={open}
        width="60%"
        centered
        destroyOnClose
        maskClosable={false}
        onCancel={() => {
          setOpen(false);
          reset();
        }}
        afterClose={reset}
        footer={
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={() => {
                setOpen(false);
                reset();
              }}
            >
              Close
            </Button>
          </div>
        }
        title={null}
      >
        <div
          style={{
            height: "65vh",
            minHeight: 520,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ padding: "14px 16px" }}>
            <div
              style={{
                width: "52%",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <UploadOutlined style={{ color: "#e55353", fontSize: 18 }} />
              <Text style={{ color: "#e55353", fontWeight: 700, fontSize: 18 }}>
                UPLOAD INSURANCE TEMPLATE
              </Text>
            </div>
            <div className="model_top"></div>
          </div>

          <div style={{ flex: 1, display: "flex" }}>
            <div style={{ width: "50%",  }}>
              <div style={{ padding: 24, height: "100%" }}>
                <Upload
                  accept=".xlsx,.xls"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  disabled={excelUploading}
                >
                  <Button className="btnNew" loading={excelUploading}>
                    <UploadOutlined />
                    Upload
                  </Button>
                </Upload>
                {!!errorMsg && (
                  <div
                    style={{
                      marginTop: 16,
                      background: "#d9534f",
                      color: "#fff",
                      padding: "12px 14px",
                      borderRadius: 4,
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <ExclamationCircleOutlined />
                    <span style={{ fontWeight: 600 }}>{errorMsg}</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{ width: "50%" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <InfoCircleOutlined style={{ color: "#1677ff", fontSize: 18 }} />
                <Text style={{ fontWeight: 600, fontSize: 16, color: "#666" }}>
                  Information Detail
                </Text>
              </div>

              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 36px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 26, color: "#8c8c8c", lineHeight: 1.3 }}>
                    <br />
                  To Use Upload Insurance
                       <br />
                  Please Drag & Drop a xlsx File
                  </div>

                  <div
                    style={{
                      marginTop: 24,
                      fontSize: 18,
                      color: "#8c8c8c",
                      lineHeight: 1.6,
                    }}
                  >
                   
                     Upload insurance allows users to add the same policy number
                    <br />
                  For the file template and format description of xlsx, please click the link below.
                  </div>

                  <div style={{ marginTop: 34 }}>
                    <Button
                      type="primary"
                      size="large"
                      icon={<FileTextOutlined />}
                      onClick={handleDownloadInstruction}
                      style={{
                        height: 56,
                        padding: "0 28px",
                        fontSize: 18,
                        textDecoration: "underline",
                      }}
                    >
                      Download Insurance Template
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* 校验结果弹窗 */}
      <Modal
        title="Excel Check Result"
        open={checkModalVisible}
        onCancel={handleCancelCheck}
        maskClosable={false}
        width={800}
        zIndex={2000}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            <Button onClick={handleCancelCheck} disabled={submitting}>
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleConfirmUpload}
              loading={submitting}
              disabled={submitting}
            >
              Submit
            </Button>
          </div>
        }
      >
        {renderCheckResult()}
      </Modal>
    </>
  );
});

export default UploadTransactionsModal;